<lib-toast></lib-toast>
<!-- Skip link target id must match shell #main-content -->
<a href="#main-content" class="skip-link">Skip to main content</a>
@if (isLoggedIn()) {
  <bhub-shell />
} @else {
  <router-outlet />
}
